import APIra from 'apira';
import adapter from './axios';

export const createAPIra = () => new APIra({ adapter });
